var _dec, _dec2, _dec3, _dec4, _dec5, _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action, computed, set } from '@ember/object';
import { isNone } from '@ember/utils';
import { inject as service } from '@ember/service';
import Money from '@square/dashboard-money/models/money';
import MarketInputTextFormatted from '@dashboard/shared-ui/components/market-input-text-formatted';
let MarketInputCurrency = (_dec = service('formatter'), _dec2 = computed('value.currencyCode'), _dec3 = computed('currencyCode', 'currentPrecision', 'formatter', 'minPrecision', 'hideCurrencySymbol'), _dec4 = computed('_placeholderOverride', 'currencyCode', 'focused', 'formatter'), _dec5 = computed('value'), _class = class MarketInputCurrency extends MarketInputTextFormatted {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "formatterService", _descriptor, this);
    // passed in
    _defineProperty(this, "autocomplete", void 0);
    _defineProperty(this, "inputClassNames", void 0);
    _defineProperty(this, "value", void 0);
    _defineProperty(this, "hideCurrencySymbol", void 0);
    _defineProperty(this, "maxAmount", void 0);
  }
  onMoneyValueChange() {}
  onTextDidChange() {}
  get currencyCode() {
    return this.value?.currencyCode || Money.defaultCurrencyCode;
  }
  get formatter() {
    /*
     * The setup can take place before the currency code is set correctly,
     * so get the default if we don't have one yet.
     */
    const currencyCode = this.currencyCode;
    return this.formatterService.getCurrencyFormatter(currencyCode, this.hideCurrencySymbol);
  }
  get placeholder() {
    if (this._placeholderOverride) {
      return this._placeholderOverride;
    }
    return this.focused ? this.formatter.format(0, this.currencyCode) : this.formatter.format(0);
  }
  set placeholder(value) {
    set(this, '_placeholderOverride', value);
  }
  get valueAsMoney() {
    if (isNone(this.value)) {
      return null;
    }
    let valueAsMoney;
    if (Money.detectInstance(this.value)) {
      valueAsMoney = this.value;
    } else {
      valueAsMoney = Money.fromCents(this.value);
    }
    return valueAsMoney;
  }
  handleDidEndEditing(event) {
    const newInputValue = event.target.value;
    let cents = this.formatter.parse(newInputValue);
    if (this.maxAmount && cents > this.maxAmount) {
      cents = this.maxAmount;
    }
    const newValue = isNone(cents) ? null : Money.fromCents(cents, this.currencyCode);

    // Here we set the value of both the input and the marketInput because
    // the marketInput requires the value attribute to correctly style the market label.
    this.input.value = this.valueToShow(newValue);
    this.marketInput.value = this.valueToShow(newValue);
    set(this, 'value', newValue);
    const valueToStore = this.valueToStore(this.value);
    this.onChange(valueToStore?.amount);
    this.onMoneyValueChange(valueToStore);
  }
  valueToShow(money) {
    if (Money.detectInstance(money) && money.isDefined()) {
      return this.formatter.format(money.amount);
    } else if (typeof money === 'number') {
      return this.formatter.format(money);
    } else {
      return '';
    }
  }
  valueToStore(value) {
    if (isNone(value)) {
      return null;
    }
    if (Money.detectInstance(value)) {
      return value;
    } else if (typeof value === 'number') {
      return Money.fromCents(value);
    } else {
      return Money.fromCents(this.formatter.parse(value), this.currencyCode);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "formatterService", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "currencyCode", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "currencyCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "formatter", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "formatter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "placeholder", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "placeholder"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "valueAsMoney", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "valueAsMoney"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleDidEndEditing", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleDidEndEditing"), _class.prototype), _class);
export { MarketInputCurrency as default };